import axios from "../helper/axiosIntance";
import { baseUrl } from "../helper/constant";
import Header from "./Header";
import EncryptDecrypt from "./EncryptDecrypt";

export default class FeelingsTrackingService {
  static list(params) {
    Header.setHeaders();
    return axios.post(
      `${baseUrl}/feelings-tracking/list`,
      EncryptDecrypt.encrypt(params)
    );
  }
}
